export const DOMAIN_ACTION = {
  NEW_CHARGE_INPUT: 'new-charge-input',
  COMPUTE_RESULT_STATISTICS: 'compute-result-statistics',
};

export const VIEW_ACTION = {
  UPDATE_LOTTO_LIST: 'update-lotto-list',
  UPDATE_VISIBLE_STATE: 'update-visible-state',
  RENDER_STATISTICS: 'render-statistics',
  BIND_EVENT_HANDLER: 'bind-event-handler',
  MODAL_CANCEL: 'modal-cancel',
};
